<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          @click="onClick"
        >
          <span class="brand-logo">
            <b-img
                style="max-height: 56px"
                :src="appLogoHorizontalImage"
                alt="logo"
            />
          </span>
<!--          <h2 class="brand-text mb-0">-->
<!--            {{ appName }}-->
<!--          </h2>-->
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import {getUserData} from '@/auth/utils'
import router from '@/router'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    let appName = null
    let appLogoHorizontalImage = null
    const user = getUserData()
    if (user && user.logo_svg && user.logo_svg.url) {
      appLogoHorizontalImage = user.logo_svg.url
    } else if (user && user.program_version === 'profman_dental') {
      appLogoHorizontalImage = $themeConfig.app.appLogoHorizontalProfmanDental
    } else {
      appLogoHorizontalImage = $themeConfig.app.appLogoHorizontalProfmanHealth
    }
    const onClick = () => {
      const defaultRouteName = 'patient-cards'
      let available = false
      if (user) {
        if (user.isRoot) {
          available = true
        }
        available = user.system_modules.includes(defaultRouteName)
      }
      if (available && router.currentRoute.name !== defaultRouteName) {
        router.push('/')
      }
    }
    return {
      appName,
      appLogoHorizontalImage,
      onClick
    }
  },
}
</script>

<style>

</style>
